/*
 * ERZEUGT von `tools/icon-einbau.mjs` — nicht von Hand ändern.
 *
 * Die Zuordnung „Name in der App → Zeichen im IcoMoon-Font" bestimmt der Nutzer auf
 * `docs/icon-zuordnung.html`; sie liegt in `assets/icomoon/zuordnung.json`. Hier stehen nur
 * die Zeichen, die daraus folgen, samt Quellname als Kommentar.
 *
 * Neu erzeugen:  node tools/icon-einbau.mjs
 */

export const GLYPHEN = {
  arrowMark: '\ue994', // bookmark
  arrowRight: '\uee1e', // arrow-right12
  back: '\uedc3', // arrow-left
  camera: '\ue944', // camera
  check: '\ued6f', // checkmark
  chevronDown: '\uedbf', // arrow-down
  chevronRight: '\uedbb', // arrow-right
  clock: '\uea4d', // clock
  close: '\ued6c', // cross
  cloudDownload: '\uec7a', // cloud-download2
  comment: '\ueac4', // bubble
  cover: '\ued87', // stop2
  doc: '\ue99d', // file-empty
  dot: '\ue903', // dot
  ellipse: '\uee73', // radio-unchecked
  exam: '\ue9cf', // stack3
  hide: '\uecb1', // eye-blocked
  hourglass: '\ueb20', // hour-glass2
  info: '\ued63', // info
  list: '\uec59', // list
  logout: '\ued7b', // exit3
  markArrow: '\uee1d', // arrow-up-right5
  markCircle: '\uee77', // circle
  markNumber: '\ue90c', // circle-1
  markText: '\ueeaa', // text-color
  mic: '\ue98b', // mic2
  minus: '\ued5a', // minus
  numberMark: '\uec58', // list-numbered
  pause: '\ued86', // pause2
  pencil: '\ue90e', // pencil
  pin: '\uea3c', // location5
  play: '\ued85', // play4
  plus: '\ued59', // plus
  qr: '\ue9f8', // qrcode
  rect: '\uee67', // checkbox-unchecked
  redo: '\ueaa6', // redo
  refresh: '\uea4b', // reset
  scribble: '\ue911', // pencil4
  send: '\uec09', // paperplane
  settings: '\ueb5f', // cog
  sheet: '\uec51', // clipboard2
  sleep: '\ue90b', // sleep
  swap: '\ue904', // swap
  text: '\ue905', // text
  trash: '\uebfe', // bin2
  undo: '\ueaa5', // undo
  unplugged: '\ue909', // unplugged
  user: '\ueaf7', // user
  users: '\ueaf8', // users
  video: '\ue963', // video-camera2
  warning: '\ued4f', // warning
} as const;

/** Die Namen, unter denen die Oberfläche ihre Icons anspricht. */
export type IconName = keyof typeof GLYPHEN;
